module.exports = __webpack_public_path__ + "img/figure.cf092ab.png";